var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "content__page-title" }, [_vm._v("Сертификаты")]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "form-data form-data_type_ui_settings form-data_theme_bordered",
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchQuery,
              expression: "searchQuery",
            },
          ],
          staticClass: "price-range__input",
          attrs: {
            type: "text",
            name: "query",
            placeholder: "Введите ключевое слово",
          },
          domProps: { value: _vm.searchQuery },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.searchQuery = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "documents__list" },
          _vm._l(_vm.paginatedData, function (key) {
            return _c("div", { staticClass: "documents__list-doc" }, [
              _c("span", { staticClass: "action-link__text" }, [
                _vm._v(_vm._s(key.name)),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-cert__text",
                domProps: { innerHTML: _vm._s(key.certDetail) },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "action-link action-link_weight",
                  attrs: { href: key.image, target: "_blank" },
                },
                [_vm._v("\n          посмотреть\n        ")]
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.paginatedData.length == 0
          ? _c("div", { staticClass: "no-cert-mess" }, [
              _vm._v("К сожалению, сертификатов не найдено"),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }